import { cx } from '@/shared/ui/cx';

export type ProgressBarProps = {
  /** 0–1. Omit for an indeterminate bar. */
  value?: number;
  label?: string;
  tone?: 'green' | 'neutral';
  size?: 'sm' | 'md';
  className?: string;
};

export function ProgressBar({ value, label, tone = 'green', size = 'md', className }: ProgressBarProps) {
  const indeterminate = value === undefined;
  const pct = indeterminate ? 0 : Math.min(100, Math.max(0, value * 100));

  return (
    <div
      className={cx('progress', `progress--${tone}`, `progress--${size}`, className)}
      role="progressbar"
      aria-label={label}
      // An indeterminate progressbar omits aria-valuenow; that is what tells
      // assistive tech the duration is unknown.
      aria-valuenow={indeterminate ? undefined : Math.round(pct)}
      aria-valuemin={indeterminate ? undefined : 0}
      aria-valuemax={indeterminate ? undefined : 100}
    >
      <span
        className={cx('progress__fill', indeterminate && 'progress__fill--indeterminate')}
        style={indeterminate ? undefined : { width: `${pct}%` }}
        data-motion={indeterminate ? 'essential' : undefined}
      />
    </div>
  );
}
